/**
 * Identidad de ESTE dispositivo como caja.
 *
 * Existe para el local que trabaja todo en línea: una tablet en el mostrador
 * tiene que poder cambiar de cajero con cuatro dígitos, como la caja del
 * mostrador, en lugar de tipear mail y contraseña en cada relevo. Y eso
 * importa más de lo que parece: si todos entran con el mismo usuario porque es
 * lo cómodo, el arqueo deja de decir quién estuvo en el turno, que es la razón
 * de ser del módulo de caja.
 *
 * El PIN son cuatro dígitos, así que la nube solo lo acepta desde una
 * instalación REGISTRADA: alguien con permiso entra una vez con su contraseña
 * y ata este navegador a una caja. Desde ahí el PIN vale para este navegador y
 * para ninguno otro.
 *
 * En el ejecutable de la caja este identificador lo emite el propio programa y
 * viaja en config.json; acá se genera en el navegador y vive en localStorage,
 * que es el equivalente exacto: un valor en el disco de esa máquina.
 */

const CLAVE_ID = 'fruver.instalacion'
const CLAVE_REGISTRADA = 'fruver.instalacion.caja'

function leer(clave: string): string | null {
  try {
    return localStorage.getItem(clave)
  } catch {
    // Modo incógnito o almacenamiento bloqueado. Sin persistencia no hay
    // instalación posible, y el PIN simplemente no se ofrece.
    return null
  }
}

function guardar(clave: string, valor: string) {
  try {
    localStorage.setItem(clave, valor)
  } catch {
    /* sin persistencia */
  }
}

/**
 * El id de este navegador, generándolo la primera vez.
 *
 * Son 32 caracteres hexadecimales, el mismo formato que usa el ejecutable, y
 * se piden al generador criptográfico del navegador: un id previsible sería
 * una llave que se adivina.
 */
export function instalacionDeEsteNavegador(): string {
  const guardado = leer(CLAVE_ID)
  if (guardado !== null && guardado.length >= 16) return guardado

  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)

  const nuevo = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('')
  guardar(CLAVE_ID, nuevo)

  return nuevo
}

/** Si este navegador ya está atado a una caja (y a cuál). */
export function cajaDeEsteNavegador(): { id: number; nombre: string } | null {
  const crudo = leer(CLAVE_REGISTRADA)
  if (crudo === null) return null

  try {
    const dato = JSON.parse(crudo) as { id?: unknown; nombre?: unknown }

    return typeof dato.id === 'number' && typeof dato.nombre === 'string'
      ? { id: dato.id, nombre: dato.nombre }
      : null
  } catch {
    return null
  }
}

export function recordarCajaDeEsteNavegador(caja: { id: number; nombre: string } | null) {
  if (caja === null) {
    try {
      localStorage.removeItem(CLAVE_REGISTRADA)
    } catch {
      /* nada que hacer */
    }

    return
  }

  guardar(CLAVE_REGISTRADA, JSON.stringify(caja))
}
